import React from 'react';

// 메인페이지
const Home = React.lazy(() => import('./pages/home'));
// 상단메뉴 하위 페이지
const CategoryPages = React.lazy(() => import('./pages/products/index'));
// 로그인
const Login = React.lazy(() => import('./pages/auth/login'));
// 회원가입
const Welcome = React.lazy(() => import('./pages/auth/signup/welcome'));
const SignUp = React.lazy(() => import('./pages/auth/signup'));
const DoctorRegistrationPage = React.lazy(() => import('./pages/auth/signup/doctor'));
const HospitalRegistrationPage = React.lazy(() => import('./pages/auth/signup/hospital'));
// 아이디 찾기, 비밀번호 찾기, 로그인
const FindId = React.lazy(() => import('./pages/auth/find-id'));
const ResetPassword = React.lazy(() => import('./pages/auth/reset-password'));
// 마이페이지
const MyPage = React.lazy(() => import('./pages/mypage'));
const Orders = React.lazy(() => import('./pages/mypage/shopping/orders')); // 주문/배송조회
const OrderDetail = React.lazy(() => import('./pages/mypage/shopping/orders/[orderId]')); // 주문 상세
const Returns = React.lazy(() => import('./pages/mypage/shopping/returns')); // 취소/반품/교환
const ReturnCancelDetail = React.lazy(() => import('./pages/mypage/shopping/returns/cancel/[orderId]')); // 취소/반품/교환 상세페이지
const Inquiries = React.lazy(() => import('./pages/mypage/shopping/inquiries')); // 상품 문의
const Wishlist = React.lazy(() => import('./pages/mypage/shopping/wishlist')); // 찜 상품
const FrequentPurchases = React.lazy(() => import('./pages/mypage/shopping/frequent')); // 자주 구매한 상품
const Points = React.lazy(() => import('./pages/mypage/benefits/points')); // 예치금/포인트
const DepositPointSuccess = React.lazy(() => import('./pages/mypage/benefits/points/success')); // 예치금/포인트 성공
const DepositPointFail = React.lazy(() => import('./pages/mypage/benefits/points/fail')); // 예치금/포인트 실패
const Coupons = React.lazy(() => import('./pages/mypage/benefits/coupons')); // 쿠폰함
const Negotiations = React.lazy(() => import('./pages/mypage/benefits/negotiations')); // 우리 병원 가격협상
const Profile = React.lazy(() => import('./pages/mypage/account/profile')); // 내 정보 관리
const SalesLedger = React.lazy(() => import('./pages/mypage/account/sales-ledger')); // 매출원장 조회
const Notifications = React.lazy(() => import('./pages/mypage/notifications/settings')); // 알림 설정
const FAQ = React.lazy(() => import('./pages/mypage/support/faq')); // 자주 묻는 질문
const Notices = React.lazy(() => import('./pages/mypage/support/notice')); // 공지사항
const NoticeDetail = React.lazy(() => import('./pages/mypage/support/notice/detail')); // 공지사항 상세
// 병원전용안내페이지
const HospitalMembershipBenefits = React.lazy(() => import('./pages/benefits'));
// 프로모션
const Drugs = React.lazy(() => import('./pages/promotions/drugs')); // 의약품
const Devices = React.lazy(() => import('./pages/promotions/devices')); // 의료기기
const Supplies = React.lazy(() => import('./pages/promotions/supplies')); // 의료소모품
const HospitalOnly = React.lazy(() => import('./pages/promotions/hospital-only')); // 내 병원 전용가
const Negotiation = React.lazy(() => import('./pages/promotions/negotiation')); // 가격 협상
const Favorites = React.lazy(() => import('./pages/promotions/favorites')); // 자주 사는 제품
// 에러페이지
const Page404 = React.lazy(() => import('./pages/page404/Page404'));
const Page500 = React.lazy(() => import('./pages/page500/Page500'));
// 개발용 페이지
const SamplePage = React.lazy(() => import('./pages/sample'));
const IconGallery = React.lazy(() => import('./pages/foundation/icons'));
// 장바구니
const Cart = React.lazy(() => import('./pages/cart'));
// 결제
const Payment = React.lazy(() => import('./pages/payment'));
const PaymentSuccess = React.lazy(() => import('./pages/payment/success'));
const PaymentFail = React.lazy(() => import('./pages/payment/fail'));
const PaymentError = React.lazy(() => import('./pages/payment/error'));
const OrderComplete = React.lazy(() => import('./pages/order-complete'));
// 상품 상세
const ProductDetail = React.lazy(() => import('./pages/products/[id]/index'));
// 검색결과
const SearchResult = React.lazy(() => import('./pages/search/index'));

// Base routes
const baseRoutes = [
  // 메인페이지
  { path: '/', element: Home, auth: false, showQuickMenu: true },
  // 상단메뉴 하위 페이지
  { path: '/products', element: CategoryPages, auth: false, showQuickMenu: true },
  // 로그인
  { path: '/login', element: Login, auth: false, showQuickMenu: false },
  // 회원가입
  { path: '/signup', element: SignUp, auth: false },
  { path: '/signup/doctor', element: DoctorRegistrationPage, auth: false, showQuickMenu: false },
  { path: '/signup/hospital', element: HospitalRegistrationPage, auth: false, showQuickMenu: false },
  { path: '/signup/welcome', element: Welcome, auth: false, showQuickMenu: false },
  // 아이디 찾기, 비밀번호 찾기, 로그인
  { path: '/findid', element: FindId, auth: false },
  { path: '/resetpassword', element: ResetPassword, auth: false },
  // 마이페이지
  { path: '/mypage', element: MyPage, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/shopping/orders', element: Orders, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/shopping/orders/:orderId', element: OrderDetail, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/shopping/returns', element: Returns, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/shopping/returns/cancel/:orderId', element: ReturnCancelDetail, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/shopping/inquiries', element: Inquiries, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/shopping/wishlist', element: Wishlist, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/shopping/frequent', element: FrequentPurchases, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/benefits/points', element: Points, auth: false, showQuickMenu: true },
  {
    path: '/mypage/benefits/points/success',
    element: DepositPointSuccess,
    auth: false,
    showQuickMenu: false,
  },
  {
    path: '/mypage/benefits/points/fail',
    element: DepositPointFail,
    auth: false,
    showQuickMenu: false,
  },
  { path: '/mypage/benefits/coupons', element: Coupons, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/benefits/negotiations', element: Negotiations, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/account/profile', element: Profile, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/account/sales-ledger', element: SalesLedger, auth: false, showQuickMenu: true },
  { path: '/mypage/notifications/settings', element: Notifications, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/support/faq', element: FAQ, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/support/notice', element: Notices, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/mypage/support/notice/detail', element: NoticeDetail, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  // 병원전용안내페이지
  { path: '/benefits/membership/hospital', element: HospitalMembershipBenefits, auth: false, showQuickMenu: true },
  // 프로모션
  { path: '/promotions/drugs', element: Drugs, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/promotions/devices', element: Devices, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/promotions/supplies', element: Supplies, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/promotions/hospital-only', element: HospitalOnly, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/promotions/negotiation', element: Negotiation, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  { path: '/promotions/favorites', element: Favorites, auth: false, showQuickMenu: true }, // TODO: 개발을 위해 false로 변경
  // 장바구니
  { path: '/cart', element: Cart, auth: false, showQuickMenu: false },
  // 결제
  { path: '/payment', element: Payment, auth: false, showQuickMenu: false },
  { path: '/payment/success', element: PaymentSuccess, auth: false, showQuickMenu: false },
  { path: '/payment/fail', element: PaymentFail, auth: false, showQuickMenu: false },
  { path: '/payment/error', element: PaymentError, auth: false, showQuickMenu: false },
  { path: '/payment/order-complete', element: OrderComplete, auth: false, showQuickMenu: false },
  // 상품 상세
  { path: '/products/:id', element: ProductDetail, auth: false, showQuickMenu: true },
  // 검색결과
  { path: '/search', element: SearchResult, auth: false, showQuickMenu: true },
  { path: '/search/negotiation', element: SearchResult, auth: false, showQuickMenu: true },
  // 에러페이지
  { path: '/404', element: Page404, auth: false, showQuickMenu: false },
  { path: '/500', element: Page500, auth: false, showQuickMenu: false },
];

// 개발 환경 라우트
const devRoutes = [
  { path: '/foundation/icons', element: IconGallery, auth: false, showQuickMenu: true },
  { path: '/sample', element: SamplePage, auth: false, showQuickMenu: true },
];

// 개발 환경 감지 함수
const isDevelopmentEnvironment = () => {
  // 로컬
  if (import.meta.env.DEV) return true;

  // 도메인 기반 감지
  const hostname = window.location.hostname;
  return hostname.includes('dev.') || hostname.includes('localhost') || hostname.includes('127.0.0.1');
};

// 환경별 라우트 조합
const routes = [...baseRoutes, ...(isDevelopmentEnvironment() ? devRoutes : [])];

export default routes;
